import moment from 'moment';
import React, { useEffect, useState } from 'react';
import api from 'services';
import RangeDates from './RangeDates';
import Chart from './Chart';

export default function CompositionStats() {
    const [from, setFrom] = useState(moment().add(-1, 'w').startOf('day').toDate());
    const [until, setUntil] = useState(moment().endOf('day').toDate());
    const [stats, setStats] = useState([]);

    const modifyFrom = (_from) => {
        setFrom(_from);
    };

    const modifyUntil = (_until) => {
        setUntil(moment(_until).endOf('day').toDate());
    };

    const getStats = () => {
        api.getCompositionStats(from, until)
            .then((response) => {
                if (response.status > 300) {
                    return;
                }
                setStats(response.data.stats);
            });
    };

    useEffect(() => {
        getStats();
    }, [from, until]);

    return (
        <div id='statistics-emails' className='container'>
            <h3>Statistics composition</h3>
            <Chart
                stats={stats}
            />
            <RangeDates 
                from={from}
                until={until}
                modifyFrom={modifyFrom}
                modifyUntil={modifyUntil}
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/Statistics/Composition/Page.jsx